import React from 'react';
import './Main.scss';
// import mainIamge from '../static/images/accomplishment-achievement_640.jpg';

const Main = () => {
  return (
    <div className="Main">
      <div className="card rounded">
        <div className="row align-items-center">
          <div className="col-12 text-center">
            <h2>안녕하세요!</h2>
            <h1 className="service"> 전자정부서비스 </h1>
            <h2>입니다</h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
